module.exports = __webpack_public_path__ + "static/media/praxis-empfang.55630432.jpg";